import { useGetCredits } from './use-get-credits';

export const useCreditsTotalCount = (): number => {
  const creditsQuery = useGetCredits();

  return creditsQuery?.data?.pagination.totalItems ?? 0;
};
